import { useFormContext } from "react-hook-form";
import { Box, Typography, Grid, Alert, Button } from "@mui/material";

export default function PreviewForm({ onExport }) {
  const { getValues } = useFormContext();
  const values = getValues();

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h4" gutterBottom>
        Zusammenfassung
      </Typography>

      <Typography variant="body1" sx={{ mt: 2 }}>
        Mit einem Klick auf <strong>Fertigstellen</strong> wird Ihre Verfahrensdokumentation im PDF-Format heruntergeladen.
      </Typography>

      <Alert
        severity="info"
        sx={{
          mt: 3,
          mb: 2,
          borderLeft: "6px solid #1976d2",
          backgroundColor: "#e3f2fd",
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          Wichtiger Hinweis:
        </Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Bitte klicken Sie unbedingt auch auf den Button{" "}
          <strong>„Exportieren“</strong>, bevor Sie das Fenster schließen.
          <br />
          So sichern Sie Ihre eingegebenen Daten ab und können diese später
          wieder <strong>hochladen</strong>, um Änderungen an Ihrer
          Verfahrensdokumentation vorzunehmen – ohne alles neu eintragen zu
          müssen.
        </Typography>
      </Alert>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Tipp: Speichern Sie die exportierte Datei an einem sicheren Ort (z. B.
        in Ihrem Projektordner), damit Sie sie bei zukünftigen Anpassungen
        schnell wiederfinden.
      </Typography>

      {/* Export Button */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={onExport}
          sx={{
            px: 4,
            py: 1.5,
            fontSize: "1.1rem",
            background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
            boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
            "&:hover": {
              background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
            }
          }}
        >
          📁 Daten exportieren
        </Button>
      </Box>
    </Box>
  );
}
